import { render, staticRenderFns } from "./event-history.html?vue&type=template&id=5b6af3c6&"
import script from "./event-history.js?vue&type=script&lang=js&"
export * from "./event-history.js?vue&type=script&lang=js&"
import style0 from "./event-history.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "../profile.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports